import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { HtmlPageMeta } from '~/components/HtmlPageMeta/HtmlPageMeta'
import { HtmlPageMetaResourceService } from '~/components/HtmlPageMeta/HtmlPageMetaResourceService'
import { Gallery } from '~/components/Gallery/Gallery'
import {
  OrganizerFilterComponentDtoTranslator
} from '~/modules/Organizers/Infrastructure/OrganizerFilterComponentDtoTranslator'
import { ComponentTrophyDtoTransformer } from '~/modules/Products/Infrastructure/ComponentTrophyDtoTransformer'
import { TrophiesPageViewModel } from '~/modules/PresentationAdapters/TrophiesPageAdapter'
import styles from './MarketTrophiesPage.module.scss'

export interface MarketTrophiesPageProps {
  viewModel: TrophiesPageViewModel
}

export const MarketTrophiesPage: NextPage<MarketTrophiesPageProps> = ({ viewModel }) => {
  const { t } = useTranslation('gallery')
  const trophies =
    viewModel.trophies.map((trophy) => ComponentTrophyDtoTransformer.fromApplication(trophy))
  const organizers = viewModel.organizers.map(
    (organizer) => OrganizerFilterComponentDtoTranslator.fromOrganizerApplicationDto(organizer)
  )

  const htmlPageMetaUrlProps = (
    new HtmlPageMetaResourceService(t('gallery_page_title'), t('gallery_page_description'))
  ).getProperties()
  const htmlPageMetaProps = { ...viewModel.htmlPageMetaContextProps, ...htmlPageMetaUrlProps }

  return (
    <>
      <HtmlPageMeta { ...htmlPageMetaProps } />

      <div className={ styles.marketTrophiesPage }>
        <section className={ styles.marketTrophiesPage__container }>
          <header className={ styles.marketTrophiesPage__header }>
            <h1 className={ styles.marketTrophiesPage__title }>
              { t('title', { defaultValue: 'Gallery' }) }
            </h1>
          </header>

          <Gallery
            trophies={ trophies }
            organizerId={ viewModel.organizerId }
            minMemories={ viewModel.minMemories }
            disciplineOptions={ viewModel.disciplineOptions }
            discipline={ viewModel.discipline }
            positionOptions={ viewModel.positionOptions }
            position={ viewModel.position }
            organizers={ organizers }
            appearance="museumHome"
            showTitle={ false }
            showTrophiesTitle={ false }
            trophyAppearance="museumGallery"
          />
        </section>
      </div>
    </>
  )
}
